import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as StoreActions from 'x/modules/store/StoreState'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContent from 'xui/components/XContent'
import HStack from 'xui/components/HStack'
import {
  getSelectedStore,
  getEditingStore,
  getSubscription,
  getSelectedStoreOrdersDates,
  getSelectedStoreOrdersDatesOptionKey,
} from 'x/redux/selectors'
import {
  ActionApiParams,
  IApiOptions,
  IPaymentAccount,
  ISelectedStoreMap,
  IStoreSettingPreOrderNavParams,
  IXDateRangeSelectorOptionKey,
  IXScreenProps,
  IDateRange,
  ISelectedStore,
} from 'x/types'
import * as util from 'x/utils/util'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as NavActions from 'x/utils/navigation'

import XText from 'xui/components/XText'
import VStack from 'xui/components/VStack'
import XSwitch from 'xui/components/XSwitch'
import XNumericInput from 'xui/components/XNumericInput'
import XButton from 'xui/components/XButton'
import XCard from 'xui/components/XCard'
import BankIcon from 'xui/components/BankIcon'
import XIcon from 'xui/components/XIcon'
import HelpButton from 'xui/components/HelpButton'
import XSpinner from 'xui/components/XSpinner'
import { RefreshControl } from 'react-native'
import VerifySlipIcon from 'xui/components/VerifySlipIcon'
import _ from 'lodash'
import XOverlayLoading from 'xui/components/XOverlayLoading'
import XRadio from 'xui/components/XRadio'
import Box from 'xui/components/Box'

interface IStoreSettingPreOrderProps extends IXScreenProps<IStoreSettingPreOrderNavParams> {
  selectedStore: ISelectedStoreMap

  onChangeEditingStore: (newValue: Partial<ISelectedStore>) => void
  submitEditing: ActionApiParams
  resetEditingStore: () => void
  editingStore: ISelectedStoreMap
}

interface IStoreSettingPreOrderState {
  isInitialized?: boolean

  isAllowNegativeStockSubmitting?: boolean
  isAllowNegativeStockAllProductsSubmitting?: boolean
}

class StoreSettingPreOrder extends React.Component<IStoreSettingPreOrderProps, IStoreSettingPreOrderState> {
  static displayName = 'StoreSettingPreOrder'

  inProcess?: boolean

  constructor(props) {
    super(props)

    this.state = {
      isInitialized: false,

      isAllowNegativeStock: false,
      isAllowNegativeStockSubmitting: false,
      isAllowNegativeStockAllProductsSubmitting: false,
    }
  }

  async componentDidMount() {
    await this._initialize()
    // await this._onRefresh()
  }

  _initialize = async () => {
    const { resetEditingStore, selectedStore } = this.props
    resetEditingStore()

    const isAllowNegativeStock = selectedStore.get('s_allow_negative_stock') || false
    this.setState({ isInitialized: true, isAllowNegativeStock })
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _doSubmit = async (key: string, value: any): Promise<{ store: ISelectedStore }> => {
    const { selectedStore, submitEditing } = this.props
    const store_id = util.getNavParam(this.props, 'store_id', selectedStore.get('id'))

    const submitBody = {}
    submitBody[key] = value

    try {
      const res: any = await new Promise((resolve) => {
        // @ts-ignore
        submitEditing({
          body: { store_id, ...submitBody },
          successCallback: resolve,
          failedCallback: () => resolve(null),
        })
      })
      // console.log('res => ', res)

      if (res && 'store' in res) {
        return res
      }
    } catch (error) {
      console.log('_doSubmit error => ', error)
    }

    return null
  }

  // _getIsAllowNegativeStock = (): boolean => {
  //   // const { selectedStore } = this.props
  //   // return selectedStore.get('s_allow_negative_stock') || false
  //   const { editingStore } = this.props
  //   return editingStore.get('s_allow_negative_stock') || false
  // }

  _getIsAllowNegativeStockAllProducts = () => {
    const { selectedStore } = this.props
    return selectedStore.get('s_allow_negative_stock_all_products') || false
  }

  _onChangeIsAllowNegativeStock = async (newValue: boolean) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { isAllowNegativeStockSubmitting } = this.state
    if (isAllowNegativeStockSubmitting) {
      return
    }
    await util.setStatePromise(this, { isAllowNegativeStockSubmitting: true })

    // const { onChangeEditingStore } = this.props
    // onChangeEditingStore({ s_allow_negative_stock: newValue })
    // await util.delay(1000) // wait for UX

    const res = await this._doSubmit('s_allow_negative_stock', newValue)
    let newAllowNegativeStock
    if (res) {
      newAllowNegativeStock = res.store?.s_allow_negative_stock
    } else {
      newAllowNegativeStock = !newValue
    }

    await util.setStatePromise(this, { isAllowNegativeStockSubmitting: false, isAllowNegativeStock: newAllowNegativeStock })
    await util.delay(1000) // wait for UX
    this.inProcess = false
  }

  _setIsAllowNegativeStockAllProducts = async (newValue: boolean) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { isAllowNegativeStockAllProductsSubmitting } = this.state
    if (isAllowNegativeStockAllProductsSubmitting) {
      return
    }
    await util.setStatePromise(this, { isAllowNegativeStockAllProductsSubmitting: true })

    const { onChangeEditingStore } = this.props
    onChangeEditingStore({ s_allow_negative_stock_all_products: newValue })
    await util.delay(100) // wait for UX
    await this._doSubmit('s_allow_negative_stock_all_products', newValue)

    await util.setStatePromise(this, { isAllowNegativeStockAllProductsSubmitting: false })
    await util.delay(1000) // wait for UX
    this.inProcess = false
  }

  // @ts-ignore
  // renderRefreshControl = () => (p.op.isWeb() ? undefined : <RefreshControl refreshing={false} onRefresh={this._onRefresh} />)

  render() {
    const { isInitialized, isAllowNegativeStockAllProductsSubmitting, isAllowNegativeStockSubmitting, isAllowNegativeStock } = this.state

    // const isAllowNegativeStock = this._getIsAllowNegativeStock()
    const isAllowNegativeStockAllProducts = this._getIsAllowNegativeStockAllProducts()

    return (
      <XContainer>
        <XCustomHeader title='ตั้งค่าการใช้งานพรีออเดอร์' headerLeftProps={{ backIcon: true, onPressItem: this._goBack }} />
        <XContent>
          <VStack w='full' px='4' py='3' space='1.5' bg='white'>
            <HStack space='2'>
              <VStack flex={1}>
                <XText variant='active' fontSize='md'>
                  อนุญาตให้ พรีออเดอร์สินค้า ได้
                </XText>

                <XText variant='inactive'>
                  {'พรีออเดอร์ หรือ '}
                  <XText bold>"สั่งเกินจำนวนพร้อมขายได้"</XText>
                  {' คือการอนุญาตให้สามารถเปิดออเดอร์ได้แม้ จำนวน '}
                  <XText bold>"พร้อมขาย"</XText>
                  {' ของสินค้ามีน้อยกว่าจำนวนสินค้าที่ระบุขณะสร้างออเดอร์ การเปิดใช้งานฟีเจอร์นี้เหมาะสำหรับหลายกรณี เช่น'}
                  {'\n\n- ต้องการขายสินค้าก่อนมีสต๊อกสินค้าจริง'}
                  {'\n- ต้องรอผลิตสินค้า หรือสั่งซื้อเข้าคลัง หลังจากที่มีออเดอร์สั่งซื้อ'}
                  {'\n\nการตั้งค่ามี 2 ลักษณะใช้งาน คือ '}
                  <XText bold>แบบบางสินค้าในร้าน</XText>
                  {' และ '}
                  <XText bold>แบบทุกสินค้าในร้าน</XText>
                  {' (เลือกเพียง 1 อย่าง)'}
                </XText>
              </VStack>

              <HStack w='80px' h='34px' justifyContent='flex-end' alignItems='center' space='1'>
                {isAllowNegativeStockSubmitting ? <XSpinner size='sm' /> : null}
                <XSwitch
                  disabled={isAllowNegativeStockSubmitting}
                  value={isAllowNegativeStock}
                  onValueChange={this._onChangeIsAllowNegativeStock}
                />
              </HStack>
            </HStack>

            {isAllowNegativeStock && !isAllowNegativeStockSubmitting && (
              <VStack w='full' space='2'>
                <HStack alignItems='center' space='1'>
                  <XText variant='active' fontSize='md'>
                    ลักษณะการพรีออเดอร์
                  </XText>
                  {isAllowNegativeStockAllProductsSubmitting ? <XSpinner size='sm' /> : null}
                </HStack>

                <HStack space='2' alignItems='center'>
                  <XRadio
                    disabled={isAllowNegativeStockAllProductsSubmitting}
                    checked={isAllowNegativeStockAllProducts === false}
                    onPress={() => this._setIsAllowNegativeStockAllProducts(false)}
                  />

                  <VStack flex={1}>
                    <XText variant='inactive'>
                      ใช้กับ<XText bold>บางสินค้า</XText>ในร้าน
                    </XText>
                    <XText variant='inactive' fontSize='xs'>
                      {'(คุณต้องเปิดการใช้งานพรีออเดอร์ของแต่ละสินค้าที่ต้องการเอง ที่หน้ารายการสต๊อก หรือ รายละเอียดสินค้า กดปุ่ม '}
                      <XText bold variant='inactive'>
                        (...)
                      </XText>
                      {' ของตัวเลือกสินค้าที่ต้องการตั้งค่า > กด ตั้งค่าสินค้า)'}
                    </XText>
                  </VStack>

                  <Box w='40px' />
                </HStack>

                <HStack space='2' alignItems='center'>
                  <XRadio
                    disabled={isAllowNegativeStockAllProductsSubmitting}
                    // renderLabel={isAllowNegativeStockAllProductsSubmitting ? () => <XSpinner size='sm' /> : undefined}
                    checked={isAllowNegativeStockAllProducts === true}
                    onPress={() => this._setIsAllowNegativeStockAllProducts(true)}
                  />

                  <VStack flex={1}>
                    <XText variant='inactive'>
                      ใชักับ<XText bold>ทุกสินค้า</XText>ในร้าน
                    </XText>
                    <XText variant='inactive' fontSize='xs'>
                      (ทุกสินค้าในร้านสามารถถูกสั่งเกินจำนวนพร้อมขายได้เลย โดยไม่ต้องตั้งค่าใดๆ เพิ่มเติม)
                    </XText>
                  </VStack>

                  <Box w='40px' />
                </HStack>
              </VStack>
            )}
          </VStack>
        </XContent>
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    editingStore: getEditingStore(state),
    // subscription: getSubscription(state),

    // selectedStoreOrdersDates: getSelectedStoreOrdersDates(state),
    // selectedStoreOrdersDatesOptionKey: getSelectedStoreOrdersDatesOptionKey(state),
  }),
  (dispatch) => ({
    submitEditing: bindActionCreators(StoreActions.submitEditingStore, dispatch),
    resetEditingStore: bindActionCreators(StoreActions.resetEditingStore, dispatch),
    onChangeEditingStore: bindActionCreators(StoreActions.onChangeEditingStore, dispatch),
    // storeActions: bindActionCreators(StoreState, dispatch),
  })
)(StoreSettingPreOrder)
